import {
  CHANGE_SIDE,
  CHANGE_PRODUCT,
  CHANGE_VARIANT,
  SAVE_DESIGN,
  SUCCESS,
  CHANGE_DESIGN,
  TOGGLE_STATIC_OBJECTS,
  RESTORE_DESIGN
} from "../constants/action-types";

export default (condition = {}, action) => {
  const {type, payload, response} = action;
  switch (type) {
    case CHANGE_SIDE:
      return {
        ...condition,
        side: payload.next.side,
        design: payload.next.design,
        dimensions: payload.next.dimensions,
        dpi: payload.next.dpi
      };
    case CHANGE_PRODUCT + SUCCESS:
      return {
        ...response.condition,
        design: payload.next.design
      };
    case TOGGLE_STATIC_OBJECTS:
      return {
        ...condition,
        design: payload.designs[0].design
      };
    case CHANGE_DESIGN:
      return {...condition, design: payload.design};
    case CHANGE_VARIANT:
      return {
        ...condition,
        variants: {...condition.variants, [payload.variant]: payload.value}
      };
    case SAVE_DESIGN + SUCCESS:
      return {
        ...response.condition
      };

    case RESTORE_DESIGN:
      return {
        ...condition,
        design: payload.designs[0].design
      };
  }
  return condition;
};
